var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamlineIconDonationCharityHandCareHeart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.492 12.73 6.733 6.722a3.411 3.411 0 0 1-.639-3.934h0a3.408 3.408 0 0 1 5.458-.888l.94.94.941-.94a3.407 3.407 0 0 1 5.457.885h0a3.409 3.409 0 0 1-.638 3.934ZM3.75 23.1l-2.014-2.385A4.5 4.5 0 0 1 .75 17.9v-5.168a1.5 1.5 0 0 1 1.5-1.5h0a1.5 1.5 0 0 1 1.5 1.5v3.75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.25 23.1v-3a4.5 4.5 0 0 0-.757-2.5l-1.142-1.714a1.4 1.4 0 0 0-1.977-.444h0a1.4 1.4 0 0 0-.476 1.79l1.352 2.25m15 3.618 2.014-2.381a4.5 4.5 0 0 0 .986-2.819v-5.168a1.5 1.5 0 0 0-1.5-1.5h0a1.5 1.5 0 0 0-1.5 1.5v3.75"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.75 23.1v-3a4.5 4.5 0 0 1 .757-2.5l1.142-1.712a1.4 1.4 0 0 1 1.977-.444h0a1.4 1.4 0 0 1 .476 1.79l-1.352 2.25"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconDonationCharityHandCareHeart);
export default __webpack_public_path__ + "static/media/streamline-icon-donation-charity-hand-care-heart.d99fd186.svg";
export { ForwardRef as ReactComponent };